export const CIVILIZATIONS = {
  ab: {
    name: "Abbasid Dynasty",
    abbr: "ab",
    slug: "abbasid",
    attribName: "abbasid",
    expansion: ["base"],
  },
  ay: {
    name: "Ayyubids",
    abbr: "ay",
    slug: "ayyubids",
    attribName: "abbasid_ha_01",
    expansion: ["sultans-ascend"],
  },
  by: {
    name: "Byzantines",
    abbr: "by",
    slug: "byzantines",
    attribName: "byzantine",
    expansion: ["sultans-ascend"],
  },
  ch: {
    name: "Chinese",
    abbr: "ch",
    slug: "chinese",
    attribName: "chinese",
    expansion: ["base"],
  },
  de: {
    name: "Delhi Sultanate",
    abbr: "de",
    slug: "delhi",
    attribName: "sultanate",
    expansion: ["base"],
  },
  en: {
    name: "English",
    abbr: "en",
    slug: "english",
    attribName: "english",
    expansion: ["base"],
  },
  fr: {
    name: "French",
    abbr: "fr",
    slug: "french",
    attribName: "french",
    expansion: ["base"],
  },
  hr: {
    name: "Holy Roman Empire",
    abbr: "hr",
    slug: "hre",
    attribName: "hre",
    expansion: ["base"],
  },
  ja: {
    name: "Japanese",
    abbr: "ja",
    slug: "japanese",
    attribName: "japanese",
    expansion: ["sultans-ascend"],
  },
  je: {
    name: "Jeanne d'Arc",
    abbr: "je",
    slug: "jeannedarc",
    attribName: "french_ha_01",
    expansion: ["sultans-ascend"],
  },
  ma: {
    name: "Malians",
    abbr: "ma",
    slug: "malians",
    attribName: "malian",
    expansion: ["base"],
  },
  mo: {
    name: "Mongols",
    abbr: "mo",
    slug: "mongols",
    attribName: "mongol",
    expansion: ["base"],
  },
  od: {
    name: "Order of the Dragon",
    abbr: "od",
    slug: "orderofthedragon",
    attribName: "hre_ha_01",
    expansion: ["sultans-ascend"],
  },
  ot: {
    name: "Ottomans",
    abbr: "ot",
    slug: "ottomans",
    attribName: "ottoman",
    expansion: ["base"],
  },
  ru: {
    name: "Rus",
    abbr: "ru",
    slug: "rus",
    attribName: "rus",
    expansion: ["base"],
  },
  zx: {
    name: "Zhu Xi's Legacy",
    abbr: "zx",
    slug: "zhuxi",
    attribName: "chinese_ha_01",
    expansion: ["sultans-ascend"],
  },
  kt: {
    name: "Knights Templar",
    abbr: "kt",
    slug: "templar",
    attribName: "templar",
    expansion: ["knights-of-cross-and-rose"],
  },
  hl: {
    name: "House of Lancaster",
    abbr: "hl",
    slug: "lancaster",
    attribName: "lancaster",
    expansion: ["knights-of-cross-and-rose"],
  },
} as const;
